import * as React from 'react'
import { cn } from '../../lib/utils'

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'flex h-11 w-full rounded-xl border border-[rgba(67,16,7,0.12)] bg-white px-4 py-2 text-sm text-crusta-950 placeholder:text-crusta-800 shadow-[0_10px_24px_rgba(155,43,17,0.06)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-crusta-800 disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
)
Input.displayName = 'Input'
